import { financeModule } from '../../modules/finance/module';
import { itModule } from '../../modules/it/module';

export const moduleRegistry = [financeModule, itModule];

export function getModuleByKey(moduleKey) {
  return moduleRegistry.find((module) => module.key === moduleKey) || null;
}

export function getHomeWidgetRenderer(widget) {
  return getModuleByKey(widget.module_key)?.homeWidgetRenderers?.[widget.kind] || null;
}

export function getModuleLabel(moduleKey) {
  return getModuleByKey(moduleKey)?.label || moduleKey;
}

export function getAvailableModules(user) {
  return moduleRegistry.filter((module) => module.isAvailable(user));
}

export function getModuleRoutes() {
  return moduleRegistry.flatMap((module) => module.routes || []);
}

export function getAvailableSettingsSections(user) {
  return getAvailableModules(user).flatMap((module) => (
    (module.settingsSections || []).map((section) => ({
      ...section,
      moduleKey: module.key,
    }))
  ));
}